(function ($) {
  "use strict";

  // javascript code here. i.e.: $(document).ready( function(){} );
  $(document).ready(function () {
    if ($("#rank-math-toc").length > 0) {
      $("#rank-math-toc > p , #rank-math-toc > h2").click(function (e) {
        e.preventDefault();
        $(this).toggleClass("active");
        $(this).next().slideToggle();
      });
    }
  });
})(jQuery);
